<template>
  <v-col :cols="12" :sm="12" :md="12">
    <Alertas :notificacaoSocket="alertaSocket" :texto="alerta.texto" :tipo="alerta.tipo"></Alertas>

    <DataTable
      v-show="showSkeletonTable == false"
      :tableTitle="'Dispensa de Setores'"
      :newRowmodalButtonText="'Nova Dispensa'"
      :tableHeader="headers"
      :tableRows="listOfDispensasDeSetores"
      :isViewEdit="true"
      :isEdit="false"
      :isFinish="false"
      :isDevolucao="true"
      :isDel="false"
      :isPrint="true"
      :totalItens="totalDispensa"
      v-on:datatable-newrow="insertNewDispensa"
      v-on:datatable-viewrow="viewDispensaSetor"
      v-on:datatable-print="imprimir"
      v-on:datatable-devolucao="modalDeletar"
      v-on:datatable-update-page="updatePage"
      v-on:datatable-update-search="updateSearch"
    ></DataTable>

    <SkeletonTable v-show="showSkeletonTable == true" :showSkeletonTable="showSkeletonTable"></SkeletonTable>

    <TipoImpressao
      v-if="$store.state.numeroEndereco != 127 || $store.state.numeroEndereco != '127'"
      :showModal="modalImpressao.modalAberta"
      v-on:close-modal="modalImpressao.modalAberta = false"
      v-on:event-gerar-pdf="gerarPDF(modalImpressao.conteudo)"
      v-on:event-gerar-nota="gerarNota(modalImpressao.conteudo)"
      v-on:event-gerar-comprovante="gerarComprovante(modalImpressao.conteudo)"
      v-on:event-gerar-cupom="imprimirCupom(modalImpressao.conteudo)"
    />

    <TipoImpressaoCustomizada v-if="$store.state.numeroEndereco == 127 || $store.state.numeroEndereco == '127'" :showModal="modalImpressao.modalAberta" :dadosDispensa="modalImpressao.conteudo" :descricaoTela="'DispensaSetor'" v-on:close-modal="modalImpressao.modalAberta = false" />

    <Loading :open="loading" />

    <ModalCustomSize
      :isTheModalOpen="modalCustomSize.isOpen"
      :modalButtonText="modalCustomSize.buttonText"
      :modalFormTitle="modalCustomSize.formTitle"
      :modalType="modalCustomSize.modalType"
      :isLoadingRequestDisable="modalCustomSize.isLoadingRequestDisable"
      :isModalButtonVisible="modalCustomSize.isButtonsVisible"
      :isModalButtonDisabled="modalCustomSize.isButtonsDisabled"
      v-on:formmodal-close="modalCustomSize.isOpen = false"
      v-on:formmodal-action="insert"
    >
      <v-row>
        <v-col cols="12">
          <AlertasModal :tipo="alertaModal.tipo" :texto="alertaModal.texto"></AlertasModal>
        </v-col>
      </v-row>

      <v-form v-model="isFormValid">
        <v-row>
          <v-col cols="12" v-if="!modalCustomSize.isEdit">
            <v-autocomplete label="Lista de Setores" :items="listOfSetores" v-model="setorSelecionado" :readonly="modalCustomSize.isEdit" :rules="[rules.required]"> </v-autocomplete>
          </v-col>

          <v-col cols="12" v-if="!modalCustomSize.isEdit">
            <v-checkbox label="Mostrar insumos restritos para dispensa" v-model="modalCustomSize.actualEdit.dispensarMedicamentos" :false-value="false" :true-value="true"></v-checkbox>
          </v-col>

          <v-expand-transition>
            <v-col
              cols="12"
              v-if="
                !modalCustomSize.isEdit &&
                  modalCustomSize.actualEdit.dispensarMedicamentos &&
                  $store.state.numeroEndereco != '116' &&
                  $store.state.numeroEndereco != '122' &&
                  $store.state.numeroEndereco != '61' &&
                  $store.state.numeroEndereco != '139' &&
                  $store.state.numeroEndereco != '93' &&
                  $store.state.numeroEndereco != '128'
              "
            >
              <v-text-field v-model="modalCustomSize.actualEdit.senhaDispensa" label="Senha para liberação" @keypress="(event) => filter(event)"></v-text-field>
            </v-col>
          </v-expand-transition>

          <v-expand-transition>
            <v-col cols="6" v-if="!modalCustomSize.isEdit && showSubestoquesField">
              <v-autocomplete label="Lista de Subestoques" :items="listaDeSubestoque" v-model="subestoqueSelecionado" clearable></v-autocomplete>
            </v-col>
          </v-expand-transition>

          <v-expand-transition>
            <v-col v-if="!modalCustomSize.isEdit && !mostrarAviso">
              <v-autocomplete label="Lista de Familias" :items="listaDeFamilias" v-model="familiaSelecionada" clearable></v-autocomplete>
            </v-col>
          </v-expand-transition>

          <v-expand-transition>
            <v-col cols="12" v-if="!modalCustomSize.isEdit && !mostrarAviso && !mostrarAvisoFamilia">
              <v-autocomplete label="Lista de Produtos" :items="listaDeMateriais" v-model="itemSelecionado"></v-autocomplete>
            </v-col>
          </v-expand-transition>

          <v-expand-transition>
            <v-col cols="12" v-if="!modalCustomSize.isEdit && mostrarAviso">
              <v-alert v-show="mensagemSubestoque.erro" transition="scale-transition" type="warning" text>{{ mensagemSubestoque.text }}</v-alert>
            </v-col>
          </v-expand-transition>

          <v-expand-transition>
            <v-col cols="12" v-if="!modalCustomSize.isEdit && !mostrarAviso && mostrarAvisoFamilia">
              <v-alert v-show="mensagemFamilia.erro" transition="scale-transition" type="warning" text>{{ mensagemFamilia.text }}</v-alert>
            </v-col>
          </v-expand-transition>

          <v-col cols="12" v-if="!modalCustomSize.isEdit">
            <v-card>
              <v-card-title>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line></v-text-field>
              </v-card-title>

              <v-data-table :headers="headersItens" :search="search" :items="modalCustomSize.actualEdit.listaDeItensEnviados" disable-sort>
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>Produtos Dispensados</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-4" class="grey--text text--lighten-5" @click="listarItensVencidosDispensa">Adicionar Produtos Vencidos/Próximos a Vencer</v-btn>
                  </v-toolbar>
                </template>

                <template v-slot:[`item.validade`]="{ item }">
                  <v-chip :color="corValidade(item.validade)" dark>{{ item.validade }}</v-chip>
                </template>

                <template v-slot:[`item.item.validade`]="{ item }">
                  <v-chip :color="corValidade(item.item.validade)" dark>{{ item.item.validade }}</v-chip>
                </template>

                <template v-if="!modalCustomSize.isEdit" v-slot:[`item.quantidade`]="props">
                  <v-text-field style="max-width:250px" v-model="props.item.quantidade" :rules="[rules.required]" label="Quantidade para Dispensar" single-line @keypress="(event) => filter(event)"></v-text-field>
                </template>

                <template v-if="!modalCustomSize.isEdit" v-slot:[`item.actions`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon small @click="deleteItemFromList(item)" v-bind="attrs" v-on="on">mdi-delete</v-icon>
                    </template>
                    <span>Excluir</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card>
          </v-col>

          <v-col cols="12" v-if="modalCustomSize.isEdit">
            <DataTable v-if="dispensaAntiga" :tableTitle="'Produtos Dispensados para o setor: ' + modalCustomSize.actualEdit.nomeSetor" :tableHeader="headersItensDispensadosAntigo" :tableRows="modalCustomSize.actualEdit.listaDeItensEnviados"></DataTable>

            <DataTable
              v-if="!dispensaAntiga"
              :tableTitle="'Produtos Dispensados para o setor: ' + modalCustomSize.actualEdit.nomeSetor"
              :tableHeader="headersItensDispensados"
              :tableRows="modalCustomSize.actualEdit.listaDeItensEnviados"
              :isDevolucaoProduto="true"
              v-on:datatable-devolucao-produto="modalDeletarItem"
            ></DataTable>
          </v-col>
        </v-row>
      </v-form>
    </ModalCustomSize>

    <AlertaSnackbar :habilitar="alertaSnackbar.mostrar" :texto="alertaSnackbar.texto" :cor="alertaSnackbar.cor" v-on:snack-close="alertaSnackbar.mostrar = false" />

    <DeleteItemModal :showModalDelete="modalDelete.abrir" :textModalDelete="modalDelete.texto" :buttomTextModalDelete="'Devolver'" v-on:close-modal="modalDelete.abrir = false" v-on:on-response-modal-delete="deleteDispensa"></DeleteItemModal>

    <DeleteItemModal :showModalDelete="modalDeleteItem.abrir" :textModalDelete="modalDeleteItem.texto" :buttomTextModalDelete="'Devolver'" v-on:close-modal="modalDeleteItem.abrir = false" v-on:on-response-modal-delete="deletarItem"></DeleteItemModal>
  </v-col>
</template>

<script>
import DataTable from "@/components/DataTable2.vue";
import axios from "../plugins/axios";
import Loading from "../components/Loading.vue";
import ModalCustomSize from "@/components/ModalCustomSize.vue";
import store from "@/store/index";
import SkeletonTable from "../components/SkeletonTable";
import TipoImpressao from "../components/TipoImpressao";
import TipoImpressaoCustomizada from "../components/TipoImpressaoCustomizada";
import Alertas from "../components/Alertas.vue";
import AlertasModal from "../components/AlertasModal.vue";
import DeleteItemModal from "../components/DeleteItemModal.vue";
import AlertaSnackbar from "../components/AlertaSnackbar.vue";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver";
import Blob from "blob";

export default {
  components: {
    DataTable,
    Loading,
    ModalCustomSize,
    SkeletonTable,
    TipoImpressao,
    TipoImpressaoCustomizada,
    DeleteItemModal,
    Alertas,
    AlertasModal,
    AlertaSnackbar,
  },

 

  data: () => ({
    //Paginação
    pageDispensa: 1,
    searchDispensa: null,
    totalDispensa: null,
    //Fim da paginação
    rules: {
      required: (value) => !!value || "Requer o campo!",
    },

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    alerta: {
      texto: "",
      tipo: "",
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    alertaModal: {
      texto: "",
      tipo: "",
    },

    alertaSnackbar: {
      mostrar: false,
      texto: null,
      cor: "red",
    },

    mensagemSubestoque: {
      erro: false,
      text: null,
    },

    mensagemFamilia: {
      erro: false,
      text: null,
    },

    showSkeletonTable: true,
    loading: false,
    showTextField: false,
    isFormValid: false,
    search: "",
    dispensaKit: false,
    showSubestoquesField: false,
    mostrarItensPadronizadosKit: false,
    mostrarAviso: false,
    mostrarAvisoFamilia: false,
    dispensaAntiga: false,

    //#region Headers
    headers: [
      {
        text: "ID",
        value: "numeroDispensaSetor",
      },
      {
        text: "Nome Setor",
        value: "nomeSetor",
      },
      {
        text: "Nome Unidade",
        value: "endereco.nomeEndereco",
      },
      {
        text: "Responsável pela Dispensa",
        value: "funcionario.nomeFuncionario",
      },
      {
        text: "Data Dispensa",
        value: "dataDispensa",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    headersItens: [
      {
        text: "ID",
        value: "value",
      },
      {
        text: "Lote",
        value: "lote",
      },
      {
        text: "Nome Produto",
        value: "nomeItem",
      },
      {
        text: "Validade",
        value: "validade",
      },
      {
        text: "Qt. Total",
        value: "quantidadeAtual",
      },
      {
        text: "Qt. que deseja remover do Estoque (Digite Abaixo)",
        value: "quantidade",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    headersItensKit: [
      {
        text: "ID",
        value: "numeroItemSistemaUnidade",
      },
      {
        text: "Nome Produto",
        value: "nomeItemSistema",
      },
      {
        text: "Qt. Padrão",
        value: "quantidade",
      },
    ],

    headersItensDispensados: [
      {
        text: "ID",
        value: "itemDispensa.numeroItemDispensa",
      },
      {
        text: "Lote",
        value: "item.lote",
      },
      {
        text: "Nome Produto",
        value: "itemSistema.nomeItemSistema",
      },
      {
        text: "Validade",
        value: "item.validade",
      },
      {
        text: "Qt. Atual",
        value: "itemUnidade.quantidadeEstoque",
      },
      {
        text: "Quantidade Dispensada",
        value: "itemDispensa.quantidadeDispensada",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    headersItensDispensadosAntigo: [
      {
        text: "ID",
        value: "itemDispensa.numeroItemDispensa",
      },
      {
        text: "Lote",
        value: "item.lote",
      },
      {
        text: "Nome Produto",
        value: "itemSistema.nomeItemSistema",
      },
      {
        text: "Validade",
        value: "item.validade",
      },
      {
        text: "Quantidade Dispensada",
        value: "itemDispensa.quantidadeDispensada",
      },
    ],
    //#endregion

    modalCustomSize: {
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      isLoadingRequestDisable: false,
      isButtonsVisible: true,
      isButtonsDisabled: false,
      actualEdit: {
        numeroEndereco: store.state.numeroEndereco,
        descricaoTela: "dispensaSetor",
        numeroSetor: null,
        numeroDispensaSetor: null,
        nomeSetor: null,
        nomeUnidade: store.state.nomeEndereco,
        nomeResponsavelUnidade: null,
        nomeFuncionario: null,
        dataDispensa: null,
        quantidadeRecebidaItem: null,

        dispensarMedicamentos: false,
        senhaDispensa: null,

        listaDeItensEnviados: [],
      },
    },

    modalDelete: {
      abrir: false,
      texto: "Deseja realmente devolver essa Dispensa de Setor?",
      actualEdit: {
        dispensaSetorSelecionado: null,
        dataDispensa: null,
        listaDeItens: [],
      },
    },

    modalDeleteItem: {
      abrir: false,
      texto: "Deseja realmente fazer a devolução desse Produto para seu estoque?",
      actualEdit: {
        dispensaSetorSelecionado: null,
        itemSelecionado: null,
      },
    },

    modalImpressao: {
      modalAberta: false,
      conteudo: null,
    },

    semMedicamentos: true,

    //Array populado pela função initialize
    listaDeSubestoque: [],
    listOfDispensasDeSetores: [],
    listOfSetores: [],
    listaDeMateriais: [],
    listaDeKits: [],
    listaDeItensKit: [],
    listaDeFamilias: [
      {
        value: 1,
        text: "Medicações",
      },
      {
        value: 2,
        text: "Materiais",
      },
      {
        value: 3,
        text: "Psicotrópicos",
      },
      {
        value: 4,
        text: "Saneantes",
      },
      {
        value: 5,
        text: "Cosméticos",
      },
      {
        value: 6,
        text: "Nutrição ",
      },
      {
        text: "Antimicrobianos",
        value: 7,
      },
      {
        text: "Amostra Grátis",
        value: 8,
      },
      {
        text: "Maleta de Emergência",
        value: 9,
      },
      {
        text: "Doação",
        value: 10,
      },
      {
        value: 11,
        text: "Teste Rápido",
      },
      {
        value: 12,
        text: "USO INTERNO"
      }
    ],
    familiaSelecionada: null,
    kitSelecionado: null,
    subestoqueSelecionado: null,
    selectedStatus: null,
    setorSelecionado: null,
    itemSelecionado: null,
  }),

  created() {
    this.gerarNovoToken();
  },

  watch: {
    async dispensaKit() {
      if (this.dispensaKit) {
        await this.listaKits();
      } else {
        this.listaDeKits = [];
        this.kitSelecionado = null;
        this.subestoqueSelecionado = null;
      }
    },

    async kitSelecionado() {
      if (this.kitSelecionado) {
        this.mostrarItensPadronizadosKit = false;
        await this.listaItensKit(this.kitSelecionado);
        await this.listaItensPadronizadosKit(this.kitSelecionado);
      } else {
        this.modalCustomSize.actualEdit.listaDeItensEnviados = [];
        this.mostrarItensPadronizadosKit = false;
      }
    },

    async subestoqueSelecionado() {
      this.familiaSelecionada = null;
      await this.listarItensDisponiveisNaUnidade(this.subestoqueSelecionado, this.familiaSelecionada);
    },

    async familiaSelecionada() {
      await this.listarItensDisponiveisNaUnidade(this.subestoqueSelecionado, this.familiaSelecionada);
    },

    "modalCustomSize.actualEdit.dispensarMedicamentos"() {
      if (this.modalCustomSize.actualEdit.dispensarMedicamentos == true) {
        this.semMedicamentos = false;
        this.modalCustomSize.actualEdit.listaDeItensEnviados = [];
        this.listarItensDisponiveisNaUnidade(this.subestoqueSelecionado, this.familiaSelecionada);
      } else {
        this.semMedicamentos = true;
        this.modalCustomSize.actualEdit.listaDeItensEnviados = [];
        this.listarItensDisponiveisNaUnidade(this.subestoqueSelecionado, this.familiaSelecionada);
      }
    },

    setorSelecionado() {
      this.modalCustomSize.actualEdit.numeroSetor = this.setorSelecionado;
    },

    isFormValid() {
      this.modalCustomSize.isButtonsDisabled = !this.isFormValid;
    },

    itemSelecionado() {
      if (this.itemSelecionado) {
        this.alertaModal.tipo = "";
        this.alertaSnackbar.mostrar = false;

        const verificarItem = this.modalCustomSize.actualEdit.listaDeItensEnviados.filter((item) => item.value == this.itemSelecionado);

        if (verificarItem.length <= 0) {
          const itemInsert = this.listaDeMateriais.filter((item) => item.value == this.itemSelecionado);

          this.modalCustomSize.actualEdit.listaDeItensEnviados.unshift(itemInsert[0]);
          this.itemSelecionado = null;
          this.modalCustomSize.isButtonsDisabled = true;
        } else {
          this.alertaModal.texto = "Esse produto já se encontra na lista. Se necessario adicionar mais, altere o valor no produto já selecionado.";
          this.alertaModal.tipo = "erro";
          this.alertaSnackbar.texto = "Esse produto já se encontra na lista. Se necessario adicionar mais, altere o valor no produto já selecionado.";
          this.alertaSnackbar.mostrar = true;
        }
      }
    },
  },

  methods: {
    async initialize() {
      this.showSkeletonTable = true;
      try {
        await this.listaDispensaSetor();
      } catch (error) {
        console.log(error);
      }
    },

    async listaDispensaSetor() {
      try {
        let listDispensa = await axios.put("dispensaSetor", { numeroEndereco: store.state.numeroEndereco, page: this.pageDispensa, search: this.searchDispensa }, this.config);
        if (!listDispensa.data || listDispensa.data.length > 0) {
          this.listOfDispensasDeSetores = listDispensa.data;
          this.totalDispensa = listDispensa.data[0].total;
        }
        this.showSkeletonTable = false;
      } catch (error) {
        console.log(error);
        this.showSkeletonTable = false;
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      }
    },

    async updateSearch(search) {
      if (search) {
        this.searchDispensa = search;
        this.pageDispensa = 1;
        await this.listaDispensaSetor();
      } else {
        this.pageDispensa = 1;
      }
    },

    async updatePage(pagination) {
      this.pageDispensa = pagination.page;
      await this.listaDispensaSetor();
    },

    async recoverListOfSetores() {
      try {
        let responseSetor = await axios.put("setorUnidade", { numeroEndereco: store.state.numeroEndereco }, this.config);

        this.listOfSetores = responseSetor.data.map((row) => {
          return {
            value: row.numeroSetor,
            text: row.nomeSetor,
          };
        });
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      }
    },

    async listaSubestoques() {
      try {
        let responseSubestoque = await axios.put("subestoque", { numeroEndereco: store.state.numeroEndereco }, this.config);

        this.listaDeSubestoque = responseSubestoque.data.map((row) => {
          return {
            value: row.numeroSubestoque,
            text: row.nomeSubestoque,
          };
        });

        if (this.listaDeSubestoque.length > 0) {
          this.showSubestoquesField = true;
        } else {
          this.showSubestoquesField = false;
        }
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      }
    },

    async listarItensDisponiveisNaUnidade(numeroSubestoque, indicadorStatusFamilia) {
      try {
        this.listaDeMateriais = [];
        const responseItens = await axios.put("itemEstoqueUnidade", { numeroEndereco: store.state.numeroEndereco, numeroSubEstoque: numeroSubestoque, indicadorStatusFamilia: indicadorStatusFamilia, semVazios: true, semMedicamentos: this.semMedicamentos }, this.config);

        if (numeroSubestoque && !indicadorStatusFamilia && responseItens.data.length <= 0) {
          this.mostrarAviso = true;
          this.mensagemSubestoque.text = "Este subestoque não possuí produtos vinculados.";
          this.mensagemSubestoque.erro = true;
        } else if (indicadorStatusFamilia && responseItens.data.length <= 0) {
          this.mostrarAvisoFamilia = true;
          this.mensagemFamilia.text = "Esta familia não possuí produtos vinculados.";
          this.mensagemFamilia.erro = true;
        } else {
          this.mensagemSubestoque.erro = false;
          this.mensagemFamilia.erro = false;
          this.mostrarAviso = false;
          this.mostrarAvisoFamilia = false;
        }

        this.listaDeMateriais = responseItens.data.map((row) => {
          return {
            value: row.item.numeroItem,
            text: "Validade: " + row.item.validade + " " + row.nomeItemPadrao + " Lote: " + row.item.lote,
            nomeItem: row.nomeItemPadrao,
            lote: row.item.lote,
            validade: row.item.validade,
            quantidadeAtual: row.itemUnidade.quantidadeEstoque,
            numeroItemUnidade: row.itemUnidade.numeroItemUnidade,
          };
        });
      } catch (error) {
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      }
    },

    async listaKits() {
      try {
        let responseKit = await axios.put("kits", { numeroEndereco: store.state.numeroEndereco }, this.config);

        this.listaDeKits = responseKit.data.map((row) => {
          return {
            value: row.kit.numeroKit,
            text: row.kit.nomeKit,
          };
        });
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      }
    },

    async listaItensKit(numeroKit) {
      try {
        let responseItensKit = await axios.put("itensDetalhadosKit", { numeroKit: numeroKit }, this.config);

        this.modalCustomSize.actualEdit.listaDeItensEnviados = responseItensKit.data;
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      }
    },

    async listaItensPadronizadosKit(numeroKit) {
      try {
        let responseItensKit = await axios.put("itensKit", { numeroKit: numeroKit }, this.config);

        responseItensKit.data.map((itemKitSelecionado) => {
          const filtarItensListados = this.modalCustomSize.actualEdit.listaDeItensEnviados.filter((itemSelecionado) => itemSelecionado.numeroItemSistemaUnidade == itemKitSelecionado.numeroItemSistemaUnidade);
          let total = filtarItensListados.reduce(function(total, item) {
            return total + item.quantidade;
          }, 0);
          if (itemKitSelecionado.quantidade != total) {
            itemKitSelecionado.color = "red";
          } else {
            itemKitSelecionado.color = "green";
          }
        });

        this.listaDeItensKit = responseItensKit.data;
        this.mostrarItensPadronizadosKit = true;
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      }
    },

    async listarItensDispensa(dispensaSelecionada) {
      try {
        const response = await axios.put("itensDispensadosSetor", { numeroDispensaSetor: dispensaSelecionada.numeroDispensaSetor }, this.config);
        this.modalCustomSize.actualEdit.listaDeItensEnviados = response.data;

        this.dispensaAntiga = true;
        response.data.map((itemSelecionado) => {
          if (itemSelecionado.itemUnidade) {
            this.dispensaAntiga = false;
          }
        });
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      }
    },

    async listarItensVencidosDispensa() {
      try {
        const response = await axios.put("listaprodutosvencidos", { numeroUnidade: store.state.numeroEndereco }, this.config);

        if (response.data.length == 0) {
          this.alertaSnackbar.texto = "O estoque não possuí produtos fora da validade para adicionar na lista!";
          this.alertaSnackbar.mostrar = true;
        } else {
          this.modalCustomSize.actualEdit.listaDeItensEnviados = response.data;
        }
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      }
    },

    async insert() {
      this.loading = true;
      this.modalCustomSize.isButtonsDisabled = true;
      try {
        this.modalCustomSize.isLoadingRequestDisable = true;

        if (this.modalCustomSize.actualEdit.listaDeItensEnviados.length > 0) {
          this.alertaModal.tipo = "";
          this.alertaSnackbar.mostrar = false;

          await axios.post("dispensaSetor", this.modalCustomSize.actualEdit, this.config);
          this.$socket.emit("insertUnidade", this.modalCustomSize.actualEdit);

          this.modalCustomSize.isOpen = false;

          this.initialize();
        } else {
          this.alertaModal.texto = "Não foi possivel fazer a inserção, adicione produtos antes de fazer a Dispensa!";
          this.alertaModal.tipo = "erro";
          this.alertaSnackbar.texto = "Não foi possivel fazer a inserção, adicione produtos antes de fazer a Dispensa!";
          this.alertaSnackbar.mostrar = true;
          this.modalCustomSize.isButtonsDisabled = false;
        }
      } catch (error) {
        console.log(error);
        this.modalCustomSize.isOpen = true;
        this.alertaModal.texto = error.response.data.message + " Por favor atualize a pagina para recarregar o estoque!";
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message + " Por favor atualize a pagina para recarregar o estoque!";
        this.alertaSnackbar.mostrar = true;
        this.modalCustomSize.isButtonsDisabled = false;
        this.modalCustomSize.actualEdit.listaDeItensEnviados = [];
        this.listaDeMateriais = [];
        this.itemSelecionado = null;
      } finally {
        this.modalCustomSize.isLoadingRequestDisable = false;
        this.loading = false;
      }
    },

    async deleteDispensa() {
      try {
        await axios.delete("dispensaSetor", {
          data: this.modalDelete.actualEdit,
          headers: this.config.headers,
        });

        this.alerta.texto = "Dispensa removida com sucesso!";
        this.alerta.tipo = "sucesso";
      } catch (error) {
        console.log(error);
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      } finally {
        this.modalDelete.abrir = false;
        this.initialize();
      }
    },

    async deletarItem() {
      try {
        await axios.delete("itemDispensadosSetor", {
          data: this.modalDeleteItem.actualEdit,
          headers: this.config.headers,
        });

        this.alertaModal.texto = "Produto devolvido ao estoque com sucesso!";
        this.alertaModal.tipo = "sucesso";
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      } finally {
        await this.listarItensDispensa(this.modalDeleteItem.actualEdit.dispensaSetorSelecionado);
        this.modalDeleteItem.abrir = false;
      }
    },

    async insertNewDispensa() {
      this.loading = true;
      try {
        await this.verificarToken();

        this.alertaModal.tipo = "";

        this.dispensaKit = false;
        this.subestoqueSelecionado = null;
        this.kitSelecionado = null;
        this.familiaSelecionada = null;
        this.search = "";
        this.modalCustomSize.actualEdit.numeroSetor = null;
        this.modalCustomSize.actualEdit.listaDeItensEnviados = [];
        this.modalCustomSize.actualEdit.listaDeItensExcluidos = [];
        this.setorSelecionado = null;
        this.itemSelecionado = null;
        this.mostrarItensPadronizadosKit = false;

        this.semMedicamentos = true;
        this.modalCustomSize.actualEdit.dispensarMedicamentos = false;
        this.modalCustomSize.actualEdit.senhaDispensa = null;

        await this.recoverListOfSetores();
        await this.listaSubestoques();
        await this.listarItensDisponiveisNaUnidade();
      } catch (error) {
        console.log(error);
      } finally {
        this.modalCustomSize.isOpen = true;
        this.modalCustomSize.isEdit = false;
        this.modalCustomSize.isButtonsDisabled = !this.isFormValid;
        this.modalCustomSize.isButtonsVisible = true;
        this.modalCustomSize.buttonText = "Concluir";
        this.modalCustomSize.formTitle = "Nova Dispensa";
        this.loading = false;
      }
    },

    async viewDispensaSetor(dispensaSelecionada) {
      this.loading = true;
      try {
        await this.verificarToken();

        await this.listarItensDispensa(dispensaSelecionada);
        this.modalDeleteItem.actualEdit.dispensaSetorSelecionado = dispensaSelecionada;

        this.search = "";
        this.itemSelecionado = null;
        this.subestoqueSelecionado = null;
        this.kitSelecionado = null;
        this.familiaSelecionada = null;
        this.mostrarItensPadronizadosKit = false;
        this.setorSelecionado = dispensaSelecionada.numeroSetor;
        this.modalCustomSize.actualEdit.numeroSetor = dispensaSelecionada.numeroSetor;
        this.modalCustomSize.actualEdit.numeroDispensaSetor = dispensaSelecionada.numeroDispensaSetor;
        this.modalCustomSize.actualEdit.nomeSetor = dispensaSelecionada.nomeSetor;
        this.modalCustomSize.actualEdit.nomeUnidade = dispensaSelecionada.endereco.nomeEndereco;
        this.modalCustomSize.actualEdit.nomeResponsavelUnidade = dispensaSelecionada.endereco.nomeResponsavel;
        this.modalCustomSize.actualEdit.nomeFuncionario = dispensaSelecionada.funcionario.nomeFuncionario;
        this.modalCustomSize.actualEdit.dataDispensa = dispensaSelecionada.dataDispensa;

        this.semMedicamentos = true;
        this.modalCustomSize.actualEdit.dispensarMedicamentos = false;
        this.modalCustomSize.actualEdit.senhaDispensa = null;

        this.modalCustomSize.actualEdit.listaDeItensExcluidos = [];
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      } finally {
        this.alertaModal.tipo = "";
        this.modalCustomSize.isEdit = true;
        this.modalCustomSize.isButtonsDisabled = !this.isFormValid;
        this.modalCustomSize.isButtonsVisible = false;
        this.modalCustomSize.formTitle = "Visualizar Dispensa do Setor";
        this.modalCustomSize.isOpen = true;

        this.loading = false;
      }
    },

    async modalDeletar(dispensaSetor) {
      await this.verificarToken();

      const response = await axios.put("itensDispensadosSetor", { numeroDispensaSetor: dispensaSetor.numeroDispensaSetor }, this.config);
      this.modalDelete.actualEdit.listaDeItens = response.data;

      this.modalDelete.actualEdit.dispensaSetorSelecionado = dispensaSetor.numeroDispensaSetor;
      this.modalDelete.actualEdit.dataDispensa = dispensaSetor.dataDispensa;
      this.modalDelete.abrir = true;
    },

    async modalDeletarItem(itemSelecionado) {
      await this.verificarToken();

      this.modalDeleteItem.actualEdit.itemSelecionado = itemSelecionado;
      this.modalDeleteItem.abrir = true;
    },

    imprimir(conteudo) {
      this.modalImpressao.conteudo = conteudo;
      this.modalImpressao.modalAberta = true;
    },

    deleteItemFromList(value) {
      this.modalCustomSize.actualEdit.listaDeItensExcluidos.push(this.modalCustomSize.actualEdit.listaDeItensEnviados.filter((item) => item.value == value.value));
      this.modalCustomSize.actualEdit.listaDeItensEnviados = this.modalCustomSize.actualEdit.listaDeItensEnviados.filter((item) => item.value != value.value);

      if (this.modalCustomSize.actualEdit.listaDeItensEnviados.length == 0) {
        this.modalCustomSize.isButtonsDisabled = true;
      }
    },

    //#region PDF
    async gerarPDF(conteudo) {
      let dataAtual = new Date().toISOString().substr(0, 10);
      let horasAtual = new Date();
      let formattedTime = new Intl.DateTimeFormat("default", {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        timeZone: "America/Sao_Paulo",
      }).format(horasAtual);

      var pdfMake = require("pdfmake/build/pdfmake.js");

      if (pdfMake.vfs == undefined) {
        var pdfFonts = require("pdfmake/build/vfs_fonts.js");
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }

      var docDefinition = {
        info: {
          title: "Comprovante Entrega",
        },
        content: [
          { text: "Comprovante Entrega", style: "header" },
          { text: "Numero da Dispensa: " + conteudo.numeroDispensaSetor, style: "subheader" },
        ],
        styles: {
          header: {
            fontSize: 24,
            bold: true,
            alignment: "center",
            margin: [0, 32, 0, 8],
          },
          subheader: {
            fontSize: 16,
            bold: false,
            alignment: "center",
            margin: [0, 8, 0, 32],
          },
          textSignature: {
            fontSize: 16,
            bold: false,
            alignment: "center",
            margin: [0, 24, 0, 48],
          },
          bigSpace: {
            fontSize: 2,
            bold: false,
            alignment: "center",
            margin: [0, 200, 0, 8],
          },
          table: {
            alignment: "center",
            margin: [0, 32, 0, 56],
          },
          line: {
            alignment: "center",
            margin: [0, 2, 0, 2],
          },
          tableHeader: {
            bold: true,
            fontSize: 13,
            color: "black",
          },
          subtext: {
            fontSize: 14,
            bold: true,
            margin: [0, 24, 0, 4],
          },
          nameText: {
            margin: [0, 8, 0, 8],
            fontSize: 16,
          },
        },
        defaultStyle: {
          margin: [0, 1, 0, 1],
          fontSize: 12,
          // alignment: 'justify'
        },
      };

      const response = await axios.put("itensDispensadosSetor", { numeroDispensaSetor: conteudo.numeroDispensaSetor }, this.config);

      if (response.data.length > 0) {
        let tabela = [
          {
            style: "table",
            widths: ["*", "auto"],
            table: {
              headerRows: 1,
              body: [
                [
                  { text: "Número", style: "tableHeader" },
                  { text: "Lote", style: "tableHeader" },
                  { text: "Nome Item", style: "tableHeader" },
                  { text: "Validade", style: "tableHeader" },
                  { text: "Quantidade Dispensada", style: "tableHeader" },
                ],
              ],
            },
            layout: "lightHorizontalLines",
          },
        ];

        for (let item of response.data) {
          tabela[0].table.body.push([item.itemDispensa.numeroItemDispensa, item.item.lote, item.itemSistema.nomeItemSistema, item.item.validade, item.itemDispensa.quantidadeDispensada]);
        }

        docDefinition.content.push(tabela);
      } else {
        let itens = { text: "Sem itens dispensados!", style: "subtext" };
        docDefinition.content.push(itens);
      }

      docDefinition.content.push({ text: "Recebi os Itens Constantes Neste Cupom", style: "textSignature" });
      docDefinition.content.push({ canvas: [{ type: "line", x1: 0, y1: 0, x2: 520, y2: 0, lineWidth: 1, style: "line" }] });
      docDefinition.content.push({ text: "Setor: " + conteudo.nomeSetor, style: "nameText" });
      docDefinition.content.push({ text: "Funcionario: " + conteudo.funcionario.nomeFuncionario, style: "nameText" });
      if (conteudo.endereco.descricaoEndereco) {
        docDefinition.content.push({ text: "End.: " + conteudo.endereco.descricaoEndereco + ", " + conteudo.endereco.descricaoNumeroIdentificador });
      }
      if (conteudo.endereco.descricaoBairro) {
        docDefinition.content.push({ text: "Bairro: " + conteudo.endereco.descricaoBairro });
      }
      docDefinition.content.push({ text: "Municipio: Itu - SP" });
      if (conteudo.endereco.descricaoCep) {
        docDefinition.content.push({ text: "CEP: " + conteudo.endereco.descricaoCep });
      }
      docDefinition.content.push({ text: "Data: " + this._formatStringInBrazilianDateFormat(dataAtual) + " Hora: " + formattedTime });

      pdfMake.createPdf(docDefinition).open();

      this.modalImpressao.modalAberta = false;
    },

    async gerarNota(conteudo) {
      let dataAtual = new Date().toISOString().substr(0, 10);
      let horasAtual = new Date();
      let formattedTime = new Intl.DateTimeFormat("default", {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        timeZone: "America/Sao_Paulo",
      }).format(horasAtual);

      var pdfMake = require("pdfmake/build/pdfmake.js");

      if (pdfMake.vfs == undefined) {
        var pdfFonts = require("pdfmake/build/vfs_fonts.js");
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }

      var docDefinition = {
        pageOrientation: "landscape",
        info: {
          title: "Comprovante Entrega",
        },
        content: [
          { text: "Comprovante Entrega", style: "header" },
          { text: "Numero da Dispensa: " + conteudo.numeroDispensaSetor, style: "subheader" },
        ],
        styles: {
          header: {
            fontSize: 42,
            bold: true,
            alignment: "center",
            margin: [0, 32, 0, 8],
          },
          subheader: {
            fontSize: 32,
            bold: false,
            alignment: "center",
            margin: [0, 8, 0, 32],
          },
          textSignature: {
            fontSize: 28,
            bold: false,
            alignment: "center",
            margin: [0, 24, 0, 96],
          },
          bigSpace: {
            fontSize: 2,
            bold: false,
            alignment: "center",
            margin: [0, 200, 0, 8],
          },
          table: {
            alignment: "center",
            margin: [0, 56, 0, 56],
          },
          line: {
            alignment: "center",
            margin: [0, 2, 0, 2],
          },
          tableHeader: {
            bold: true,
            fontSize: 22,
            color: "black",
          },
          subtext: {
            fontSize: 28,
            bold: true,
            margin: [0, 24, 0, 4],
          },
          nameText: {
            margin: [0, 16, 0, 16],
            fontSize: 28,
          },
        },
        defaultStyle: {
          margin: [0, 1, 0, 1],
          fontSize: 28,
          // alignment: 'justify'
        },
      };

      const response = await axios.put("itensDispensadosSetor", { numeroDispensaSetor: conteudo.numeroDispensaSetor }, this.config);

      if (response.data.length > 0) {
        let tabela = [
          {
            style: "table",
            widths: ["*", "auto"],
            table: {
              headerRows: 1,
              body: [
                [
                  { text: "Número", style: "tableHeader" },
                  { text: "Lote", style: "tableHeader" },
                  { text: "Nome Item", style: "tableHeader" },
                  { text: "Validade", style: "tableHeader" },
                  { text: "Quantidade Dispensada", style: "tableHeader" },
                ],
              ],
            },
            layout: "lightHorizontalLines",
          },
        ];

        for (let item of response.data) {
          tabela[0].table.body.push([item.itemDispensa.numeroItemDispensa, item.item.lote, item.itemSistema.nomeItemSistema, item.item.validade, item.itemDispensa.quantidadeDispensada]);
        }

        docDefinition.content.push(tabela);
      } else {
        let itens = { text: "Sem itens dispensados!", style: "subtext" };
        docDefinition.content.push(itens);
      }

      docDefinition.content.push({ text: "Recebi os Itens Constantes Neste Cupom", style: "textSignature" });
      docDefinition.content.push({ canvas: [{ type: "line", x1: 0, y1: 0, x2: 760, y2: 0, lineWidth: 1, style: "line" }] });
      docDefinition.content.push({ text: "Setor: " + conteudo.nomeSetor, style: "nameText" });
      docDefinition.content.push({ text: "Funcionario: " + conteudo.funcionario.nomeFuncionario, style: "nameText" });
      if (conteudo.endereco.descricaoEndereco) {
        docDefinition.content.push({ text: "End.: " + conteudo.endereco.descricaoEndereco + ", " + conteudo.endereco.descricaoNumeroIdentificador });
      }
      if (conteudo.endereco.descricaoBairro) {
        docDefinition.content.push({ text: "Bairro: " + conteudo.endereco.descricaoBairro });
      }
      docDefinition.content.push({ text: "Municipio: Itu - SP" });
      if (conteudo.endereco.descricaoCep) {
        docDefinition.content.push({ text: "CEP: " + conteudo.endereco.descricaoCep });
      }
      docDefinition.content.push({ text: "Data: " + this._formatStringInBrazilianDateFormat(dataAtual) + " Hora: " + formattedTime });
      docDefinition.content.push({ text: ".", style: "bigSpace" });

      pdfMake.createPdf(docDefinition).open();

      this.modalImpressao.modalAberta = false;
    },

    async gerarComprovante(conteudo) {
      let dataAtual = new Date().toISOString().substr(0, 10);
      let horasAtual = new Date();
      let formattedTime = new Intl.DateTimeFormat("default", {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        timeZone: "America/Sao_Paulo",
      }).format(horasAtual);

      var pdfMake = require("pdfmake/build/pdfmake.js");

      if (pdfMake.vfs == undefined) {
        var pdfFonts = require("pdfmake/build/vfs_fonts.js");
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }

      var docDefinition = {
        info: {
          title: "Comprovante Entrega",
        },
        content: [
          { text: "Comprovante Entrega", style: "header" },
          { text: "Numero da Dispensa: " + conteudo.numeroDispensaSetor, style: "subheader" },
          { text: "-----------------------------------------------", style: "subheader" },
        ],
        styles: {
          header: {
            fontSize: 14,
            bold: true,
            alignment: "center",
            margin: [0, 32, 0, 8],
          },
          subheader: {
            fontSize: 14,
            bold: false,
            alignment: "center",
            margin: [0, 8, 0, 32],
          },
          textSignature: {
            fontSize: 14,
            bold: false,
            alignment: "center",
            margin: [0, 24, 0, 48],
          },
          bigSpace: {
            fontSize: 2,
            bold: false,
            alignment: "center",
            margin: [0, 200, 0, 8],
          },
          table: {
            alignment: "center",
            margin: [0, 32, 0, 56],
          },
          line: {
            alignment: "center",
            margin: [0, 2, 0, 2],
          },
          tableHeader: {
            bold: true,
            fontSize: 14,
            color: "black",
          },
          subtext: {
            fontSize: 14,
            bold: true,
            margin: [0, 24, 0, 4],
          },
          nameText: {
            margin: [0, 8, 0, 8],
            fontSize: 14,
          },
        },
        defaultStyle: {
          margin: [0, 1, 0, 1],
          fontSize: 12,
          // alignment: 'justify'
        },
      };

      const response = await axios.put("itensDispensadosSetor", { numeroDispensaSetor: conteudo.numeroDispensaSetor }, this.config);

      if (response.data.length > 0) {
        let tabela = [
          {
            style: "table",
            widths: ["*", "auto"],
            table: {
              headerRows: 1,
              body: [
                [
                  { text: "", style: "tableHeader" },
                  { text: "", style: "tableHeader" },
                  { text: "", style: "tableHeader" },
                  { text: "", style: "tableHeader" },
                  { text: "", style: "tableHeader" },
                  { text: "", style: "tableHeader" },
                  { text: "", style: "tableHeader" },
                ],
              ],
            },
            layout: "lightHorizontalLines",
          },
        ];

        for (let item of response.data) {
          tabela[0].table.body.push([
            "-  ",
            "Numero:" + item.itemDispensa.numeroItemDispensa + "  ",
            "Lote:" + item.item.lote + "  ",
            "Nome:" + item.itemSistema.nomeItemSistema + "  ",
            "Validade:" + item.item.validade + "  ",
            "Qtde:" + item.itemDispensa.quantidadeDispensada + "  ",
            "-----------------------------------------------",
          ]);
        }
        docDefinition.content.push(tabela);
      } else {
        let itens = { text: "Sem itens dispensados!", style: "subtext" };
        docDefinition.content.push(itens);
      }

      docDefinition.content.push({ text: "-----------------------------------------------", style: "textSignature" });
      docDefinition.content.push({ text: "Recebi os Itens Constantes Neste Cupom", style: "textSignature" });
      docDefinition.content.push({ text: "Setor: " + conteudo.nomeSetor, style: "nameText" });
      docDefinition.content.push({ text: "Funcionario: " + conteudo.funcionario.nomeFuncionario, style: "nameText" });
      if (conteudo.endereco.descricaoEndereco) {
        docDefinition.content.push({ text: "End.: " + conteudo.endereco.descricaoEndereco + ", " + conteudo.endereco.descricaoNumeroIdentificador });
      }
      if (conteudo.endereco.descricaoBairro) {
        docDefinition.content.push({ text: "Bairro: " + conteudo.endereco.descricaoBairro });
      }
      docDefinition.content.push({ text: "Municipio: Itu - SP" });
      if (conteudo.endereco.descricaoCep) {
        docDefinition.content.push({ text: "CEP: " + conteudo.endereco.descricaoCep });
      }
      docDefinition.content.push({ text: "Data: " + this._formatStringInBrazilianDateFormat(dataAtual) + " Hora: " + formattedTime });

      pdfMake.createPdf(docDefinition).open();

      this.modalImpressao.modalAberta = false;
    },
    //#endregion

    //#region GERAR CUPOM
    async imprimirCupom(conteudo) {
      try {
        let dataAtual = new Date().toISOString().substr(0, 10);
        let horasAtual = new Date();
        let formattedTime = new Intl.DateTimeFormat("default", {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZone: "America/Sao_Paulo",
        }).format(horasAtual);

        const workbook = new Workbook();

        var worksheet = workbook.addWorksheet("Comprovante Entrega", {
          properties: { tabColor: { argb: "FF00FF00" } },
          views: [{ showGridLines: false }],
        });

        worksheet.columns = [{ key: "col1", width: 50 }];

        const regex = new RegExp(".{1,35}", "g");

        let posicaoLinha = 1;
        worksheet.getCell("A" + posicaoLinha).value = "Comprovante Entrega";
        worksheet.getCell("A" + posicaoLinha).font = { name: "Arial", family: 2, size: 7, bold: true };
        worksheet.getCell("A" + posicaoLinha).alignment = { vertical: "middle", horizontal: "left" };
        posicaoLinha++;

        worksheet.getCell("A" + posicaoLinha).value = "Numero da Dispensa: " + conteudo.numeroDispensaSetor;
        worksheet.getCell("A" + posicaoLinha).font = { name: "Arial", family: 2, size: 6, bold: false };
        worksheet.getCell("A" + posicaoLinha).alignment = { vertical: "middle", horizontal: "left" };
        posicaoLinha++;

        worksheet.getRow(posicaoLinha).height = 9;
        worksheet.getCell("A" + posicaoLinha).value = "_ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _";
        worksheet.getCell("A" + posicaoLinha).font = { name: "Arial", family: 2, size: 6, bold: false };
        worksheet.getCell("A" + posicaoLinha).alignment = { vertical: "middle", horizontal: "left" };
        posicaoLinha++;
        worksheet.getRow(posicaoLinha).height = 4;
        posicaoLinha++;

        const response = await axios.put("itensDispensadosSetor", { numeroDispensaSetor: conteudo.numeroDispensaSetor }, this.config);
        const listaDeItensDisensa = response.data;

        if (listaDeItensDisensa.length > 0) {
          worksheet.getCell("A" + posicaoLinha).value = "PRODUTO";
          worksheet.getCell("A" + posicaoLinha).font = { name: "Arial", family: 2, size: 5 };
          worksheet.getCell("A" + posicaoLinha).alignment = { vertical: "middle", horizontal: "left" };
          posicaoLinha++;

          listaDeItensDisensa.map((itemSelecionado) => {
            const titulo = "N. " + itemSelecionado.itemDispensa.numeroItemDispensa + " " + itemSelecionado.itemSistema.nomeItemSistema;
            const substrings = titulo.match(regex);

            substrings.forEach((substring, index) => {
              worksheet.getRow(posicaoLinha + index).height = 8;
              worksheet.getCell(`A${posicaoLinha + index}`).font = { name: "Arial", family: 2, size: 5 };
              worksheet.getCell(`A${posicaoLinha + index}`).alignment = { vertical: "middle", horizontal: "left" };
              worksheet.getCell(`A${posicaoLinha + index}`).value = substring;
            });
            posicaoLinha += substrings.length;

            worksheet.getRow(posicaoLinha).height = 8;
            worksheet.getCell("A" + posicaoLinha).value = "Lote " + itemSelecionado.item.lote;
            worksheet.getCell("A" + posicaoLinha).font = { name: "Arial", family: 2, size: 5 };
            worksheet.getCell("A" + posicaoLinha).alignment = { vertical: "middle", horizontal: "left" };
            posicaoLinha++;

            worksheet.getRow(posicaoLinha).height = 8;
            worksheet.getCell("A" + posicaoLinha).value = "Validade " + itemSelecionado.item.validade;
            worksheet.getCell("A" + posicaoLinha).font = { name: "Arial", family: 2, size: 5 };
            worksheet.getCell("A" + posicaoLinha).alignment = { vertical: "middle", horizontal: "left" };
            posicaoLinha++;

            worksheet.getRow(posicaoLinha).height = 8;
            worksheet.getCell("A" + posicaoLinha).value = "QTDE. " + itemSelecionado.itemDispensa.quantidadeDispensada;
            worksheet.getCell("A" + posicaoLinha).font = { name: "Arial", family: 2, size: 5 };
            worksheet.getCell("A" + posicaoLinha).alignment = { vertical: "middle", horizontal: "left" };
            posicaoLinha++;
            worksheet.getRow(posicaoLinha).height = 8;
            posicaoLinha++;
            worksheet.getRow(posicaoLinha).height = 8;
          });
          posicaoLinha++;
          worksheet.getRow(posicaoLinha).height = 8;
        } else {
          worksheet.getRow(posicaoLinha).height = 9;
          worksheet.getCell("A" + posicaoLinha).value = "Sem produtos dispensados!";
          worksheet.getCell("A" + posicaoLinha).font = { name: "Arial", family: 2, size: 6, bold: false };
          worksheet.getCell("A" + posicaoLinha).alignment = { vertical: "middle", horizontal: "left" };
          posicaoLinha++;
          worksheet.getRow(posicaoLinha).height = 8;
          posicaoLinha++;
          worksheet.getRow(posicaoLinha).height = 8;
        }

        worksheet.getRow(posicaoLinha).height = 9;
        worksheet.getCell("A" + posicaoLinha).value = "_ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _";
        worksheet.getCell("A" + posicaoLinha).font = { name: "Arial", family: 2, size: 6, bold: false };
        worksheet.getCell("A" + posicaoLinha).alignment = { vertical: "middle", horizontal: "left" };
        posicaoLinha++;

        const setor = "Setor: " + conteudo.nomeSetor;
        const substringsSetor = setor.match(regex);

        substringsSetor.forEach((substring, index) => {
          worksheet.getRow(posicaoLinha + index).height = 9;
          worksheet.getCell(`A${posicaoLinha + index}`).value = substring;
          worksheet.getCell(`A${posicaoLinha + index}`).font = { name: "Arial", family: 2, size: 6, bold: false };
          worksheet.getCell(`A${posicaoLinha + index}`).alignment = { vertical: "middle", horizontal: "left" };
        });
        posicaoLinha += substringsSetor.length;

        const benificiario = "Funcionario: " + conteudo.funcionario.nomeFuncionario;
        const substringsBenificiario = benificiario.match(regex);

        substringsBenificiario.forEach((substring, index) => {
          worksheet.getRow(posicaoLinha + index).height = 9;
          worksheet.getCell(`A${posicaoLinha + index}`).value = substring;
          worksheet.getCell(`A${posicaoLinha + index}`).font = { name: "Arial", family: 2, size: 6, bold: false };
          worksheet.getCell(`A${posicaoLinha + index}`).alignment = { vertical: "middle", horizontal: "left" };
        });
        posicaoLinha += substringsBenificiario.length;

        if (conteudo.endereco.descricaoEndereco) {
          const endereco = "End.: " + conteudo.endereco.descricaoEndereco;
          const substringsEndereco = endereco.match(regex);

          substringsEndereco.forEach((substring, index) => {
            worksheet.getRow(posicaoLinha + index).height = 9;
            worksheet.getCell(`A${posicaoLinha + index}`).value = substring;
            worksheet.getCell(`A${posicaoLinha + index}`).font = { name: "Arial", family: 2, size: 6, bold: false };
            worksheet.getCell(`A${posicaoLinha + index}`).alignment = { vertical: "middle", horizontal: "left" };
          });
          posicaoLinha += substringsEndereco.length;
        }

        if (conteudo.endereco.descricaoBairro) {
          const bairro = "Bairro: " + conteudo.endereco.descricaoBairro;
          const substringsBairro = bairro.match(regex);

          substringsBairro.forEach((substring, index) => {
            worksheet.getRow(posicaoLinha + index).height = 9;
            worksheet.getCell(`A${posicaoLinha + index}`).value = substring;
            worksheet.getCell(`A${posicaoLinha + index}`).font = { name: "Arial", family: 2, size: 6, bold: false };
            worksheet.getCell(`A${posicaoLinha + index}`).alignment = { vertical: "middle", horizontal: "left" };
          });
          posicaoLinha += substringsBairro.length;
        }

        worksheet.getRow(posicaoLinha).height = 9;
        worksheet.mergeCells("A" + posicaoLinha + ":B" + posicaoLinha);
        worksheet.getCell("A" + posicaoLinha).value = "Municipio: Itu - SP";
        worksheet.getCell("A" + posicaoLinha).font = { name: "Arial", family: 2, size: 6, bold: false };
        worksheet.getCell("A" + posicaoLinha).alignment = { vertical: "middle", horizontal: "left" };
        posicaoLinha++;

        if (conteudo.endereco.descricaoCep) {
          worksheet.getRow(posicaoLinha).height = 9;
          worksheet.mergeCells("A" + posicaoLinha + ":B" + posicaoLinha);
          worksheet.getCell("A" + posicaoLinha).value = "CEP: " + conteudo.endereco.descricaoCep;
          worksheet.getCell("A" + posicaoLinha).font = { name: "Arial", family: 2, size: 6, bold: false };
          worksheet.getCell("A" + posicaoLinha).alignment = { vertical: "middle", horizontal: "left" };
          posicaoLinha++;
        }

        worksheet.getRow(posicaoLinha).height = 9;
        worksheet.mergeCells("A" + posicaoLinha + ":B" + posicaoLinha);
        worksheet.getCell("A" + posicaoLinha).value = "Data: " + this.formatarData(dataAtual) + " Hora: " + formattedTime;
        worksheet.getCell("A" + posicaoLinha).font = { name: "Arial", family: 2, size: 6, bold: false };
        worksheet.getCell("A" + posicaoLinha).alignment = { vertical: "middle", horizontal: "left" };
        posicaoLinha++;

        workbook.xlsx.writeBuffer().then(function(data) {
          var blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "Comprovante Entrega.xlsx");
        });

        this.modalImpressao.modalAberta = false;
      } catch (error) {
        console.log(error);
      }
    },
    //#endregion

    //#region Formatações
    _formatStringInBrazilianDateFormat(data) {
      if (!data) return null;
      let ano = data.split("-")[0];
      let mes = data.split("-")[1];
      let dia = data.split("-")[2];
      let dia2 = dia.substring(0, 2);

      return ("0" + dia2).slice(-2) + "/" + ("0" + mes).slice(-2) + "/" + ano;
    },

    corValidade(data) {
      if (data) {
        var ano = data.split("/")[2];
        var mes = data.split("/")[1];
        var dia = data.split("/")[0];
        // var dia2  = dia.substring(0,2)

        const dataFormatada = ano + "-" + ("0" + mes).slice(-2) + "-" + dia;

        const dias = this.verificarDias(dataFormatada);

        if (store.state.numeroEndereco == 127 || store.state.numeroEndereco == "127" || store.state.numeroEndereco == 124 || store.state.numeroEndereco == "124") {
          if (dias > 90) {
            return "green";
          } else if (dias > 0 && dias <= 90) {
            return "orange";
          } else if (dias <= 0) {
            return "red";
          }
        } else {
          if (dias > 30) {
            return "green";
          } else if (dias > 0 && dias <= 30) {
            return "orange";
          } else if (dias <= 0) {
            return "red";
          }
        }
      }
    },

    verificarDias(data) {
      const dateAtual = new Date().toISOString().substr(0, 10);
      const daterecive = data;

      const diferenceOfDates = new Date(daterecive) - new Date(dateAtual);
      const daysOfDiference = Math.ceil(diferenceOfDates / (1000 * 60 * 60 * 24));

      return daysOfDiference;
    },

    filter: function(evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[0-9]*?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    formatarData(data) {
      if (!data) return null;
      let ano = data.split("-")[0];
      let mes = data.split("-")[1];
      let dia = data.split("-")[2];
      let dia2 = dia.substring(0, 2);

      return ("0" + dia2).slice(-2) + "/" + ("0" + mes).slice(-2) + "/" + ano;
    },
    //#endregion

    //#region VERIFICAÇÕES DE TOKENS
    async gerarNovoToken() {
      try {
        const response = await axios.post("/gerartoken", {}, this.config);

        await this.$store.dispatch("setToken", response.data.token);
        await this.$store.dispatch("setAuthenticatedState", true);

        if (response.data.token != this.config.headers["x-auth-token"]) {
          this.config.headers["x-auth-token"] = response.data.token;
        }

        this.initialize();
      } catch (error) {
        console.log(error);
      }
    },

    async verificarToken() {
      try {
        await axios.post("/verifyToken", {}, this.config);
      } catch (error) {
        alert("Tempo de autenticação expirado, por favor realize o login novamente.");

        this.$store.dispatch("logout");
        this.$router.push("/login");
      }
    },
    //#endregion
  },
};
</script>
